module.exports = __webpack_public_path__ + "img/pc-banner-bg.045dfecf.png";